/**
 * Cookie Keys
 */
export const cookieKey = {
  AUTH_TOKEN: 'o-auth-token',
  REFRESH_TOKEN: 'o-refresh-token',
};

/**
 * Get Auth Header
 *
 * @param {object} cookies - cookies from vue `this` or nuxt `context.app` instance
 */
export function getAuthHeader(cookies) {
  const authToken = cookies.get(cookieKey.AUTH_TOKEN);
  if (authToken) {
    return { Authorization: 'Bearer ' + authToken };
  } else {
    return {};
  }
}
